
import './App.css';

import Header from './components/Header/Header';
import Main from './components/Main/Main';

function App() {
  return (
    <div>
      <Header></Header>
      <div >
     <Main></Main>
      </div>
    </div>
  );
}

export default App;
